export default "./send.svg"